module.exports = __webpack_public_path__ + "img/01.f7309a78.jpg";